import axios from '@/utils/request'

export function getList(params) {
  return axios.get('/admin_api/v1/base/miniprograms', {
    params
  })
}

export function getDetail(uuid) {
  return axios.get('/admin_api/v1/base/miniprograms/' + uuid)
}

export function add(data) {
  return axios.post('/admin_api/v1/base/miniprograms', data)
}

export function edit(uuid, data) {
  return axios.put('/admin_api/v1/base/miniprograms/' + uuid, data)
}

export function del(uuid) {
  return axios.delete('/admin_api/v1/base/miniprograms/' + uuid)
}

// 资料组列表
export function getResourceGroup(params) {
  return axios.get(`/admin_api/v1/base/resource_group/`, {params})
}

// 资料组新增
export function postResourceGroup(data) {
  return axios.post(`/admin_api/v1/base/resource_group/`, data)
}

// 资料组修改
export function putResourceGroup(data) {
  return axios.put(`/admin_api/v1/base/resource_group/`, data)
}

// 资料组详情
export function getReSourceGroupInfo(id) {
  return axios.get(`/admin_api/v1/base/resource_group/info/?id=${id}`)
}

// 资料组状态修改
export function putResourceGroupStatus(id) {
  return axios.put(`/admin_api/v1/base/resource_group/status/?id=${id}`)
}

// 资料分类列表
export function getResourceClassify(params) {
  return axios.get(`/admin_api/v1/base/resource_classify/`, {params})
}

// 资料分类新增
export function postResourceClassify(data) {
  return axios.post(`/admin_api/v1/base/resource_classify/`, data)
}

// 资料分类修改
export function putResourceClassify(data) {
  return axios.put(`/admin_api/v1/base/resource_classify/`, data)
}

// 资料分类状态修改
export function putResourceClassifyStatus(id) {
  return axios.put(`/admin_api/v1/base/resource_classify/status/?id=${id}`)
}

// 资料分类删除
export function delResourceClassify(id) {
  return axios.delete(`/admin_api/v1/base/resource_classify/?id=${id}`)
}

// 资料列表-vip后台
export function getReSource(params) {
  return axios.get(`/admin_api/v1/base/resource/`, {params})
}

// 资料新增
export function postReSource(data) {
  return axios.post(`/admin_api/v1/base/resource/`, data)
}

// 资料状态修改
export function putReSource(id) {
  return axios.put(`/admin_api/v1/base/resource/?id=${id}`)
}

// 资料删除
export function delReSource(id) {
  return axios.delete(`/admin_api/v1/base/resource/?id=${id}`)
}

// 资料解锁设置
export function postReSourceLockType(data) {
  return axios.post(`/admin_api/v1/base/resource/lock_type/`, data)
}

// 学科树
export function getSubjectTree(params) {
  return axios.get(`/admin_api/v1/base/drop_down/subject_tree/`, {params})
}

// 资料选择
export function getReSourceList(params) {
  return axios.get(`/admin_api/v1/base/resource/list/`, {params})
}

// 资料排序
export function getReSourceSort(params) {
  return axios.get(`/admin_api/v1/base/resource/sort/`, {params})
}